<aside class="sidebar">

  <!-- Deadline alert -->
  <div class="deadline-alert">
    <ngk-icon icon="clock" size="1rem" color="var(--color-warning-600)" />
    <p class="deadline-text">
      Filing deadline: <strong>{{ filingDeadline | date:dateFormat }} — {{ daysLeft }} days away</strong>
    </p>
  </div>

  <!-- Property summary card -->
  <div class="property-card card">
    <div class="property-header">
      <p class="property-address">{{ addressService.displayStreet }}</p>
      <p class="property-city">{{ addressService.displayCityStateZip }}</p>
      <p class="property-details">{{ assessment.displayPropertyDetails }}</p>
    </div>

<!--    <div class="property-savings">-->
<!--      <span class="savings-amount">${{ assessment.netSavings }}</span>-->
<!--      <span class="savings-period">/ year</span>-->
<!--    </div>-->
<!--    <p class="savings-note">estimated savings after 10% of savings</p>-->

    <div class="property-stats">
      <div class="stat-row">
        <span class="stat-row-label">Current assessed value</span>
        <span class="stat-row-value">{{ assessment.data?.assessment?.assessedValue | currency:'USD':'symbol':'1.0-0' }}</span>
      </div>
<!--      <div class="stat-row">-->
<!--        <span class="stat-row-label">Market estimate</span>-->
<!--        <span class="stat-row-value">{{ assessment.data?.assessment?.marketValueEstimate | currency:'USD':'symbol':'1.0-0' }}</span>-->
<!--      </div>-->
<!--      <div class="stat-row">-->
<!--        <span class="stat-row-label">Estimated tax reduction</span>-->
<!--        <span class="stat-row-value">{{ assessment.data?.taxBreakdown?.estimatedSavings | currency:'USD':'symbol':'1.0-0' }} / yr</span>-->
<!--      </div>-->
<!--      <div class="stat-row">-->
<!--        <span class="stat-row-label">Our fee (if won)</span>-->
<!--        <span class="stat-row-value">10% of savings</span>-->
<!--      </div>-->
<!--      <div class="stat-row">-->
<!--        <span class="stat-row-label">Competitors charge</span>-->
<!--        <span class="stat-row-value stat-row-value&#45;&#45;danger">25–50% of savings</span>-->
<!--      </div>-->
    </div>

    <div class="guarantees">
      <p class="guarantees-heading">GUARANTEES</p>
      @for (item of guarantees; track item) {
        <div class="guarantee-item">
          <ngk-icon icon="circle-check" size="1rem" color="var(--color-neutral-500)" />
          <span class="guarantee-text">{{ item }}</span>
        </div>
      }
    </div>
  </div>

</aside>
